import { Header } from '@tanstack/react-table'

export type KeepGroupHeaderMeta = {
    keepGroupHeader?: boolean
}

export const hasOnlyOrphanDescendants = (
    currentHeader: Header<unknown, unknown>
): boolean => {
    const meta = (
        currentHeader as unknown as {
            column?: { columnDef?: { meta?: unknown } }
        }
    ).column?.columnDef?.meta as KeepGroupHeaderMeta | undefined
    if (meta?.keepGroupHeader) {
        return false
    }

    if (currentHeader.subHeaders.length > 1) {
        return false
    }

    return currentHeader.subHeaders.every(hasOnlyOrphanDescendants)
}
